module.exports = __webpack_public_path__ + "static/img/7.f2294e8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/5/4/eng/7.png
// module id = DKJN
// module chunks = 0